import type { ChangeEvent } from "react";

interface MonthPickerProps {
  value: string | undefined;
  onChange: (ym: string) => void;
  min?: string;
  max?: string;
  disabled?: boolean;
  "aria-label"?: string;
}

function addMonths(ym: string, offset: number): string {
  const parts = ym.split("-");
  const y = Number(parts[0]);
  const m = Number(parts[1]);
  const date = new Date(Date.UTC(y, m - 1 + offset, 1));
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, "0")}`;
}

export function MonthPicker({
  value,
  onChange,
  min,
  max,
  disabled,
  "aria-label": ariaLabel,
}: MonthPickerProps) {
  const prev = value ? addMonths(value, -1) : undefined;
  const next = value ? addMonths(value, 1) : undefined;
  const prevAllowed = !disabled && value && (!min || (prev ?? "") >= min);
  const nextAllowed = !disabled && value && (!max || (next ?? "") <= max);

  function onInputChange(e: ChangeEvent<HTMLInputElement>) {
    if (e.target.value) onChange(e.target.value);
  }

  return (
    <div className="inline-flex items-center gap-1" aria-label={ariaLabel}>
      <button
        type="button"
        className="px-2 py-1 border rounded disabled:opacity-40"
        onClick={() => prev && onChange(prev)}
        disabled={!prevAllowed}
        aria-label="Vorheriger Monat"
      >
        ‹
      </button>
      <input
        type="month"
        value={value ?? ""}
        onChange={onInputChange}
        min={min}
        max={max}
        disabled={disabled}
        className="border rounded px-2 py-1"
      />
      <button
        type="button"
        className="px-2 py-1 border rounded disabled:opacity-40"
        onClick={() => next && onChange(next)}
        disabled={!nextAllowed}
        aria-label="Naechster Monat"
      >
        ›
      </button>
    </div>
  );
}
